import { SheetEventType } from "../../siteManagement/sheet";
import { Helper } from "../core/util/helper";
import { General } from "../../siteManagement/general";
import { FieldInstance } from "../core/components/field";
import { FAIcon } from "../core/components/faIcon";
import { IsSearchField } from "../core/components/isSearchField";
import { Dialog, DialogProps } from "../core/components/dialog";
import { Config } from "../core/config/config";
import { ComponentHelper } from "../core/util/componentHelper";
import { DropDownList } from "../core/components/dropDownList";
import { HTTPService } from "../core/util/httpManager";
import { DialogHelper } from "../core/util/dialogHelper";
import { IsNumericTextBox } from "../core/components/isNumericTextBox";
import { ComboBox } from "../core/components/comboBox";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
export class EntityChooseDialog extends React.Component<any, EntityChooseDialogState>{
    private factory = ComponentHelper.createFactory();
    private callBack: (closeType: CloseType, values: SearchResultData[], other: any) => void;
    private translations: StringKeyDictionary<string> = null;
    private dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    if (Helper.hasValue(this.callBack)) {
                        this.callBack(CloseType.Close, null, null);
                    }

                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    switch (this.state.searchType) {
                        case SearchType.Labour:
                            if ((this.state.values.length == 0 && !Helper.hasValue(this.state.grNr)) || (Helper.hasValue(this.callBack) && (this.state.values.length > 0) && Helper.hasValue(this.state.grNr))) {
                            this.callBack(CloseType.Ok, this.state.values, this.state.grNr);
                        } else {
                            DialogHelper.alert(this.translations["Standard.PflichtfeldAllgemein"]);
                            return false;
                        }
                        break;
                        case SearchType.Parts:
                            if (Helper.hasValue(this.callBack)) {
                                this.callBack(CloseType.Ok, this.state.values, Helper.getValueOrDefault(this.state.quantity, 1));
                            } 
                            break;
                        case SearchType.CashExpense:
                            if (Helper.hasValue(this.callBack)) {
                                this.callBack(CloseType.Ok, this.state.values, null);
                            } 
                            break;
                    }
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ values: [], dialogOpen: false, searchSheetOpen: false, grNr: null, quantity: 1 })
        },
        width: 550
    };
    private groups: { Key: number, Value: string }[];

    constructor(props) {
        super(props)
        this.state = {
            dialogOpen: false,
            searchSheetOpen: false,
            values: [],
            searchType: null,
            grNr: null
        }
        this.initApp();
    }

    private initApp = () => {
        Helper.getTranslations(["Field.Commlineitems.quantity", "WebSMS.Commercial.SelectGroup", "Field.Beleg.gruppe", "Standard.Auswählen", "Field.Barauslage.schluesseltext", "BrowserTitle.Parts.Available", "WebSMS.Commercial.Labour", "Standard.PflichtfeldAllgemein"]).then((result) => {
            if (result.Code == 0) {
                this.translations = result.Data;
                this.dialogProps.title = this.translations["Standard.Auswählen"]
                this.setState({});
            }
        });
        HTTPService.get("CommercialDocumentNGLookup/GetGroups").then((result) => {
            this.groups = result;
        });
    }

    openSearch = (searchType: SearchType, callBack: (closeType: CloseType, values: SearchResultData[], other: any) => void) => {
        this.callBack = callBack;
        if (searchType === SearchType.Labour) {
            this.setState({ dialogOpen: true, searchType: searchType, values: [] });
        } else {
            this.setState({ searchSheetOpen: true, searchType: searchType, values: [] }, () => { this.createSearchSheet(searchType) });
        }
    }

    private createDialog = () => {
        return (
            <div>
                <Dialog {...this.dialogProps} open={true}>
                    {this.createSearchField(this.state.searchType)}
                    {this.state.searchType === SearchType.Labour ? this.createGroupDropDown() : null}
                    {this.state.searchType === SearchType.Parts ? this.createNumericTextBox() : null}
                </Dialog>
            </div>
        );
    }

    private createGroupDropDown = () => {
        let props = this.factory.getDefaultDropDownProps();
        props.dataSource = this.groups;
        props.value = this.state.grNr;
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            this.setState({ grNr: value });
        }
        return (
            <FieldInstance label={this.translations["Field.Beleg.gruppe"]}>
                <DropDownList {...props}/>
            </FieldInstance>
            );
    }

    private createNumericTextBox = () => {
        let props = this.factory.getDefaultNumericTextBoxProps();
        props.value = Helper.getValueOrDefault(this.state.quantity, 1);
        props.field.min = 0;
        props.onChange = (field, value: number) => {
            this.setState({ quantity: value })
        }

        return (
            <FieldInstance label={this.translations["Field.Commlineitems.quantity"]}>
                <IsNumericTextBox {...props}/>
            </FieldInstance>
            );
    }

    private createSearchField = (searchType: SearchType) => {
        let label = "";
        let props = this.factory.getDefaultSearchFieldProps();
        props.field.searchButtonEnabled = false;
        switch (searchType) {
            case SearchType.Parts:
                label = this.translations["BrowserTitle.Parts.Available"];
                props.multiSelectMode = true;
                props.field.dataTextField = "Value";
                props.field.dataValueField = "Key";
                props.value = this.state.values;
                break;
            case SearchType.CashExpense:
                label = this.translations["Field.Barauslage.schluesseltext"];
                props.multiSelectMode = true;
                props.field.dataTextField = "Value";
                props.field.dataValueField = "Key";
                props.value = this.state.values;
                break;
            case SearchType.Labour:
                label = this.translations["WebSMS.Commercial.Labour"];
                props.multiSelectMode = false;
                props.field.autocompleteEnabled = true;
                props.field.autocompleteUrl = "CommercialDocumentNGLookup/FindLabours";
                props.field.autocompleteDataTextField = "Value";
                props.field.autocompleteTemplate = "<table cellspacing='0' style='table-layout:fixed; width:100px'><colgroup><col style='width: 250px' /><col style='width: 50px' /></colgroup><tr style='background-color:inherit'><td style='vertical-align:top; word-wrap: break-word;'>${data.Key}</td><td style='vertical-align:top'>${data.Value}</td></tr></table>";
                props.onChange = (field: any, value: any, dataItem: any) => {
                    let values: SearchResultData[] = [];
                    if (!Helper.isNullOrEmpty(value)) {
                        let item: SearchResultData = {
                            Data: dataItem,
                            Key: dataItem.Key,
                            Value: dataItem.Value,
                            Guid: null
                        };
                        values.push(item);
                    }
                    this.setState({ values: values })
                }
                if (this.state.values.length > 0) {
                    props.value = this.state.values[0].Value;
                }
                break;                
        }
        const openSheet = () => {
            this.setState({ searchSheetOpen: true, dialogOpen: false }, () => { this.createSearchSheet(searchType) })
        }
        const searchButton = (
            <>
                <div key={kendo.guid()} onClick={openSheet} style={{ borderWidth: "1px", borderStyle: "solid", borderColor: "#999", height: "28px", width: "28px", display: "flex", justifyContent: "center", alignItems: "center", marginLeft: "15px", cursor: "pointer" }}>
                    <FAIcon name={"search"} attributes={[""]} />
                </div>
            </>
        );
        const deleteButton = (
            <>
                <div key={kendo.guid()} onClick={() => { this.setState({ values: [] }) }} style={{ borderWidth: "1px", borderStyle: "solid", borderColor: "#999", height: "28px", width: "28px", display: "flex", justifyContent: "center", alignItems: "center", marginLeft: "15px", cursor: "pointer" }}>
                    <FAIcon name={"trash-alt"} attributes={["lg"]} />
                </div>
            </>
        );
        return (
            <FieldInstance label={label}>
                <div style={{ display: "flex" }}>
                    <div style={searchType !== SearchType.Labour ? { width: "270px" } : { width: "100%"}}>
                        <IsSearchField {...props}
                        />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {searchType !== SearchType.Labour ? searchButton: null}
                        {searchType !== SearchType.Labour ? deleteButton : null}
                    </div>
                </div>
            </FieldInstance>
        );
    }

    private createSearchSheet = (searchType: SearchType) => {
        let url: string = null;
        let sheetBindingSetSelectedItems: (callback) => void = null;
        let sheetBindingSetItemsSelected: (ev: { data: [] }) => void = null;
        let sheetRowClicked: (data) => void;
        switch (searchType) {
            case SearchType.Parts:
                url = "DynamicSearch/Window/Parts?multi=true&displayPattern=[[artnr]]";
                sheetBindingSetSelectedItems = (callback) => {
                    if (Helper.hasValue(callback)) {
                        let rawDS = [];
                        for (let i = 0; i < this.state.values.length; i++) {
                            let tmp = {};
                            tmp["artnr"] = this.state.values[i].Key;
                            tmp["artikelnummer"] = this.state.values[i].Value;
                            rawDS.push(tmp);
                        }
                        callback(rawDS);
                    }
                }
                sheetBindingSetItemsSelected = (ev: { data: [] }) => {
                    let artNrs: SearchResultData[] = [];
                    ev.data.forEach((dataRow) => {
                        let guid = Helper.getAttributeSavely(dataRow, "isguid");
                        artNrs.push({ Key: dataRow["artnr"], Value: dataRow["artikelnummer"], Guid: guid, Data: dataRow });
                    });
                    this.setState({ values: artNrs, searchSheetOpen: false, dialogOpen: true })
                };
                break;
            case SearchType.CashExpense:
                url = "DynamicSearch/Window/CashExpensesKeys?multi=true&displayPattern=[[nr]]";
                sheetBindingSetSelectedItems = (callback) => {
                    if (Helper.hasValue(callback)) {
                        let rawDS = [];
                        for (let i = 0; i < this.state.values.length; i++) {
                            let tmp = {};
                            tmp["nr"] = this.state.values[i].Key;
                            tmp["bezeichnung"] = this.state.values[i].Value;
                            rawDS.push(tmp);
                        }
                        callback(rawDS);
                    }
                }
                sheetBindingSetItemsSelected = (ev: { data: [] }) => {
                    let cashExpenses: SearchResultData[] = [];
                    ev.data.forEach((dataRow: any) => {
                        let guid = Helper.getAttributeSavely(dataRow, "isguid");
                        cashExpenses.push({ Key: dataRow["nr"], Value: dataRow["bezeichnung"], Guid: guid, Data: dataRow });
                    });
                    this.setState({ values: cashExpenses, searchSheetOpen: false, dialogOpen: true })
                };
                break;
            case SearchType.Labour:
                url = "DynamicSearch/Window/Labour?multi=true&displayPattern=[[ula]]";
                sheetBindingSetSelectedItems = (callback) => {
                    if (Helper.hasValue(callback)) {
                        let rawDS = [];
                        for (let i = 0; i < this.state.values.length; i++) {
                            let tmp = {};
                            tmp["ula"] = this.state.values[i].Key;
                            tmp["bezeichnung"] = this.state.values[i].Value;
                            rawDS.push(tmp);
                        }
                        callback(rawDS);
                    }
                }
                sheetBindingSetItemsSelected = (ev: { data: [] }) => {
                    let labours: SearchResultData[] = [];
                    ev.data.forEach((dataRow: any) => {
                        let guid = Helper.getAttributeSavely(dataRow, "isguid");
                        labours.push({ Key: dataRow["ula"], Value: Helper.getValueOrDefault(dataRow["bezeichnung"], dataRow["ula"]), Guid: guid, Data: dataRow });
                    });
                    this.setState({ values: labours, searchSheetOpen: false, dialogOpen: true })
                };
                break;

        }
        const sheet = General.Sheet.Manager.createSheetWithUrl(url);
        sheet.bind(SheetEventType.SetSelectedItems, sheetBindingSetSelectedItems);
        sheet.bind(SheetEventType.ItemsSelected, sheetBindingSetItemsSelected);
        sheet.bind(SheetEventType.RowClicked, sheetRowClicked);
        sheet.bind(SheetEventType.Close, () => { this.setState({ searchSheetOpen: false, dialogOpen: true }) })
    }

    render() {
        const dialog = (Helper.hasValue(this.translations) && this.state.dialogOpen && Helper.hasValue(this.state.searchType)) ? this.createDialog() : null;
        return (<>{dialog}</>);

    }
}

interface EntityChooseDialogState {
    dialogOpen: boolean;
    searchSheetOpen: boolean;
    values: SearchResultData[];
    searchType?: SearchType;
    grNr?: number;
    quantity?: number;
}

export interface SearchResultData {
    Key: any,
    Value: any,
    Data: any;
    Guid: string
}

export enum SearchType {
    Parts, CashExpense, Labour
}

export enum CloseType {
    Ok, Close
}